/* global window URL */

import { Button } from "@fluentui/react-components";
import {
  SignatureRegular,
  SendRegular,
  DocumentTableRegular,
  ArrowRightRegular,
  SignOutRegular,
} from "@fluentui/react-icons";
import React, { FC, useCallback, useState } from "react";
import useStyles from "./styles.dashboard";
import authStorage from "../../../services/storage/auth.storage";
import { uploadFile } from "../../taskpane";
import * as config from "../../../config";
import { CommandKey, DocumentUploadResBody } from "../../../types/dashboard.types";

type DashboardProps = {
  authenticator: () => void;
};

const Dashboard: FC<DashboardProps> = ({ authenticator: authenticator }) => {
  const styles = useStyles();

  const [uploading, setUploading] = useState<boolean>(false);

  const onLogout = () => {
    authenticator();
    authStorage.removeToken();
  };

  const getResolveUrl = useCallback((commandKey: CommandKey, body?: DocumentUploadResBody): URL => {
    const url = new URL(`${config.FRONTEND_URL}/en/new-signature-request`);
    url.searchParams.append("is_office_addin_enabled", "true");
    url.searchParams.append("command_key", commandKey);

    if (body) {
      url.searchParams.append("document_id", body.document_id);
      url.searchParams.append("document_url", body.document_url);
      url.searchParams.append("filename", body.filename);
    }

    return url;
  }, []);

  const onSigningThisDocument = useCallback(async () => {
    setUploading(true);
    const response = await uploadFile();

    const url = getResolveUrl("SIGN_WITH_SIGNIT", response);
    window.open(url);

    setUploading(false);
  }, []);

  const onSendingDocumentForSignature = useCallback(async () => {
    setUploading(true);
    const response = await uploadFile();

    const url = getResolveUrl("CREATE_SIGNATURE_REQUEST_WITH_SIGNIT", response);
    window.open(url);

    setUploading(false);
  }, []);

  const onStartingFromTemplate = useCallback(() => {
    const url = getResolveUrl("USE_SIGNIT_TEMPLATE");
    window.open(url);
  }, []);

  const onGoToSignIt = useCallback(() => {
    window.open(config.FRONTEND_URL);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.buttonGroup}>
        <Button
          disabled={uploading}
          appearance="primary"
          icon={<SendRegular />}
          className={styles.button}
          onClick={onSendingDocumentForSignature}
        >
          Send for Signature
        </Button>

        <Button
          disabled={uploading}
          appearance="primary"
          icon={<SignatureRegular />}
          className={styles.button}
          onClick={onSigningThisDocument}
        >
          Sign This Document
        </Button>

        <Button
          disabled={uploading}
          appearance="primary"
          icon={<DocumentTableRegular />}
          className={styles.button}
          onClick={onStartingFromTemplate}
        >
          Start from a Template
        </Button>

        <Button
          disabled={uploading}
          appearance="subtle"
          icon={<ArrowRightRegular />}
          className={styles.button}
          onClick={onGoToSignIt}
        >
          Go to SignIt
        </Button>

        <Button
          disabled={uploading}
          appearance="subtle"
          icon={<SignOutRegular />}
          className={styles.button}
          onClick={onLogout}
        >
          Logout SignIt
        </Button>
      </div>
    </div>
  );
};

export default Dashboard;
